import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import * as Api from 'api';
import { FieldList } from '../';


class ClientCustomDetails extends React.Component {
  constructor(props) {
    super(props);
    Api
      .fetchFieldGroupOrder('Client')
      .then(order => this.setState({ order }))
      .catch(this.props.notify);
  }
  state = { order: [] }
  render() {
    return (
        <div className='clearfix'>
          <div className="mb-sm">
            <FieldList
              groupOrder={this.state.order}
              readOnly={true}
              entity={this.props.client}
              fields={[...(this.props.fields || [])]}
              onChange={this.handleChange}
            />
          </div>
        </div>
      );
  }
}


const mapStateToProps = ({ client, fields }) => ({ client, fields: fields.Client });


export default connect(mapStateToProps, Actions)(ClientCustomDetails);



// WEBPACK FOOTER //
// ./src/browser/components/client/client-custom-details.js